/**
 * Standard video player placeholder dimensions
 */

/**
 * Dimensions for video players in drawer contexts (incident drawer, device drawer)
 */
export const DRAWER_VIDEO_PLAYER_WIDTH = '577px'
export const DRAWER_VIDEO_PLAYER_HEIGHT = '324px'

/**
 * Dimensions for video player in camera validation/testing contexts
 */
export const VALIDATION_VIDEO_PLAYER_WIDTH = '525px'
export const VALIDATION_VIDEO_PLAYER_HEIGHT = '290px'

/**
 * `padding-top` that reserves a 16:9 box before any media loads, as a
 * percentage of the container's width. Every player — and the chunk-loading
 * surface that stands in for one — renders into this same shape, so they all
 * read it from here rather than recomputing the ratio.
 */
export const VIDEO_ASPECT_RATIO_PADDING = `${100 / (1280 / 720)}%`
